export class PostLoginBody {
  DB?: string;
  TypeLogin?: number;

  constructor(DB: string, TypeLogin: number) {
      this.DB = DB;
      this.TypeLogin = TypeLogin;
  }
}
